import { DeliverySlotsCheckerUI } from "./DeliverySlotsCheckerUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { Product } from "../../types/types";
import {
  ensureIsActive,
  ensureIsActiveVariant,
} from "../../utils/product/ensureIsActive";

export function DeliverySlotsChecker({
  product,
  runtimeConfig,
}: Pick<StandardProps, "product" | "runtimeConfig">) {
  const { variant } = useVariant(product);
  const { availableSlotsApiBaseUrl } = runtimeConfig;

  const activeProduct = ensureIsActive(product);
  const activeVariant = ensureIsActiveVariant(variant);
  if (!activeProduct || !activeVariant) return null;

  if (
    activeVariant.availability.availableToOrder &&
    hasSchedulableDeliveryOption(product)
  ) {
    return (
      <DeliverySlotsCheckerUI
        availableSlotsBaseUrl={availableSlotsApiBaseUrl}
        skuId={activeVariant.aliases.skuId}
        variantPrice={activeVariant.price.value}
      />
    );
  }
  return null;
}

const hasSchedulableDeliveryOption = (product: Product): boolean => {
  const availableOptions = product.fulfilmentOptions?.available ?? [];
  return availableOptions.some((option) => option?.aliases?.dmsId === "26");
};
